import React from 'react';
import { Avatar } from '@mui/material';
import BeworksBotIcon from './BeworksBotIcon';

// Avatar do Agente Beworks (IA): ícone do robô sobre um tom suave da cor
// `beworksAgent` do tema, que não muda com a marca.
const BeworksAgentAvatar = React.forwardRef(({ sx, ...props }, ref) => (
  <Avatar
    ref={ref}
    {...props}
    sx={[
      (theme) => ({
        bgcolor: theme.alpha((theme.vars || theme).palette.beworksAgent.main, 0.12),
        color: 'beworksAgent.main',
      }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    <BeworksBotIcon sx={{ fontSize: 32 }} />
  </Avatar>
));

export default BeworksAgentAvatar;
